import React from 'react';
import { C } from '../data/constants';
import { NudgeLogo } from './shared/UI';

export default function Complete({ user }) {
  return (
    <div style={{
      minHeight: '100vh', background: C.bg,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: 24,
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Large N circle */}
      <div style={{
        width: 80, height: 80, borderRadius: '50%',
        background: C.teal, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: "'DM Serif Display', serif",
        fontSize: 40, fontWeight: 400, marginBottom: 24,
      }}>N</div>

      <h1 style={{
        fontFamily: "'DM Serif Display', serif",
        fontSize: 36, color: C.navy, fontWeight: 400,
        marginBottom: 10, textAlign: 'center',
      }}>Thank You</h1>

      {user?.studyId && (
        <p style={{ fontSize: 15, color: C.body, marginBottom: 28, textAlign: 'center' }}>
          Your Study ID:{' '}
          <span style={{ color: C.teal, fontWeight: 700, fontFamily: "'DM Serif Display', serif", fontSize: 17 }}>
            {user.studyId}
          </span>
        </p>
      )}

      {/* What Happens Next card */}
      <div style={{
        background: '#fff', border: `1px solid ${C.border}`,
        borderRadius: 12, padding: 32,
        maxWidth: 560, width: '100%', marginBottom: 28,
      }}>
        <h3 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: C.navy, fontWeight: 400, marginBottom: 20 }}>
          What Happens Next
        </h3>
        {[
          { icon: '1', text: 'Your responses have been recorded and de-identified for analysis.' },
          { icon: '2', text: 'You may be invited for optional follow-up interviews at 3 and 6 months ($25 each).' },
          { icon: '3', text: '$25 compensation will be processed within 2 weeks for each completed interaction.' },
          { icon: '4', text: 'If you requested an advisor connection, you will be contacted within 5 business days.' },
        ].map((item, i) => (
          <div key={i} style={{ display: 'flex', gap: 14, marginBottom: i < 3 ? 18 : 0 }}>
            <div style={{
              width: 28, height: 28, borderRadius: '50%',
              background: C.tealLight, color: C.teal,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 12, fontWeight: 700, flexShrink: 0,
            }}>{item.icon}</div>
            <p style={{ fontSize: 14, color: C.body, lineHeight: 1.65, margin: 0 }}>{item.text}</p>
          </div>
        ))}
      </div>

      {/* Resources */}
      <div style={{
        background: C.tealLight, border: `1px solid #a7f3d0`,
        borderRadius: 12, padding: '16px 24px',
        maxWidth: 560, width: '100%', marginBottom: 24,
      }}>
        <p style={{ fontSize: 13, color: '#065f46', margin: 0, lineHeight: 1.7 }}>
          <strong>Financial Resources:</strong> If you need financial guidance, free help is available at{' '}
          <a href="https://www.nfcc.org" target="_blank" rel="noopener noreferrer" style={{ color: C.teal }}>NFCC.org</a>{' '}and{' '}
          <a href="https://www.211.org" target="_blank" rel="noopener noreferrer" style={{ color: C.teal }}>211.org</a>.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        <NudgeLogo size="sm" />
        <span style={{ color: C.muted, fontSize: 13 }}>nudgeai.ai</span>
      </div>
    </div>
  );
}
